import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=authed
  const [loading, setLoading] = useState(true);

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      localStorage.removeItem("access_token");
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setUser(false);
        setLoading(false);
        return;
      }
      await refreshMe();
      setLoading(false);
    })();
  }, []);

  const loginWithPassword = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("access_token", data.access_token);
    await refreshMe();
    return data;
  };

  const finishOtpLogin = async (data) => {
    localStorage.setItem("access_token", data.access_token);
    await refreshMe();
    return data;
  };

  const login = loginWithPassword;

  const stopViewAs = async () => {
    try { await api.post("/admin/view-as/stop"); } catch {}
    await refreshMe();
  };

  const logout = async () => {
    // Update 29.4 — view-as aktifse önce onu bitir, sonra normal çıkış.
    if (user && user.view_as) {
      await stopViewAs();
      return;
    }
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("access_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithPassword, finishOtpLogin, logout, refreshMe, stopViewAs }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
